/**
 * swiper slider start up for components like  the side by side content + featured collections
 */

window.addEventListener("load", (e) => {
	const sliderContainers = [...document.querySelectorAll("[swiper-slider]")];
	if (sliderContainers.length !== 0) {
		sliderContainers.forEach((sliderContainer) => {
			const slider = sliderContainer.querySelector("[data-slider]");
			const sliderType = slider.dataset.type;
			const sliderLeftBtn = sliderContainer.querySelector("[data-swiper-previous]");
			const sliderRightBtn = sliderContainer.querySelector("[data-swiper-next]");
			const sliderDots = sliderContainer.querySelector("[data-swiper-dots]");
			const autoplayToggle = sliderContainer.querySelector("[data-autoplay-toggle]")
			const isAutoPlay = slider.getAttribute("data-isAutoplay");
			const visibleSlides = slider.getAttribute("data-slides-per-view");
			const autoplaySpeed = Number(slider.getAttribute("data-autoplay-speed"));
			const dataControlsContainer = sliderContainer.querySelector("[data-slider-controls]")
			const sliderItems = [...slider.querySelectorAll('[data-slider-item]')];
			let autoplayOptions;
			let rotationSpeed = 0;
			let controlsDisplay = {};
			if (!autoplaySpeed) {
				rotationSpeed = 4000;
			}
			else {
				rotationSpeed = autoplaySpeed * 1000;
			}
			if (isAutoPlay) {
				autoplayOptions = {
					autoplay: {
						delay: rotationSpeed,
						pauseOnMouseEnter: true
					}
				}
			}
			if (dataControlsContainer) {
				controlsDisplay = {
					on: {
						init: function () {
							toggleNavigationVisibility(this);
							setEqualSlideHeights();
							removeInert();
							setupVisibileSlides();
						},
						resize: function () {
							toggleNavigationVisibility(this);
							setEqualSlideHeights();
							setupVisibileSlides();
						}
					},
				}
			}
			let options = {
				keyboard: true,
				a11y: true,
				pagination: {
					el: sliderDots,
					bulletClass: "slider-pagination__button",
					bulletActiveClass: "slider-pagination__button--active",
					clickable: true,
					renderBullet: (index, className) => {
						return `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
					},
				},
				navigation: {
					nextEl: sliderRightBtn,
					prevEl: sliderLeftBtn,
				},
				a11y: true,
				watchOverflow: true,
				watchSlidesProgress: true,
				...autoplayOptions,
				...controlsDisplay
			};
			if (sliderType == "alert-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: false,
				};
			}
			if (sliderType == "hero-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: false,
				};
			}
			if (sliderType == "featured-collection-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: false,
					breakpoints: {
						600: {
							slidesPerView: 2,
							spaceBetween: 20,
							slidesPerGroup: 2
						},
						1200: {
							slidesPerView: 3,
							spaceBetween: 40,
							slidesPerGroup: 3
						}
					}
				};
			}
			if (sliderType == "review-slider") {
				options = {
					...options,
					slidesPerView: 1,
					loop: false,
				};
			}
			if (sliderType == 'product-media-slider') {
				const thumbSlider = document.querySelector(`[data-swiper-thumbs="product-media-slider"]`)
				options = {
					...options,
					slidesPerView: 1,
					loop: true,
					autoHeight: true,
					spaceBetween:0,
					thumbs: {
						swiper: thumbSlider
					}
				}
			}
			if (sliderType == 'product-media-slider-thumbs') {
				options = {
					...options,
					loop: true,
					spaceBetween: 10,
					slidesPerView: 4 
				}
			}
			// If Pause Button exists in HTML then apply function
			if (autoplayToggle) {
				autoplayToggle.addEventListener('click', function () {
					const autoplayStatusText = autoplayToggle.querySelector("[data-autoplay-status]");
					const autoplayPlayingText = autoplayStatusText.getAttribute("data-autoplay-playing");
					const autoplayPausedText = autoplayStatusText.getAttribute("data-autoplay-paused");
					autoplayStatusText.textContent = "";
					if (autoplayToggle.classList.contains('active')) {
						autoplayToggle.classList.remove('active');
						swiper.autoplay.start();
						autoplayStatusText.textContent = autoplayPlayingText;
						autoplayToggle.setAttribute("aria-pressed", "false");
					} else {
						autoplayToggle.classList.add('active');
						swiper.autoplay.stop();
						autoplayStatusText.textContent = autoplayPausedText;
						autoplayToggle.setAttribute("aria-pressed", "true");
					}
				});
			}
			const swiper = new Swiper(slider, options);
			const sliderAnnouncer = sliderContainer.querySelector(".swiper-notification");
			const thumbButtons = [...slider.querySelectorAll('[data-thumb-button]')];
			sliderAnnouncer.removeAttribute("aria-live")
			sliderAnnouncer.setAttribute("role", "status")
			const slides = [...slider.querySelectorAll('.swiper-slide')]
			// remove role="group" from li slide elements
			const liSlides = [...slider.querySelectorAll('[data-slider-item]')]
			// remove role="group" from li slide elements as swiper auto includes these and causes issues with ADA
			liSlides.forEach(slide => {
				slide.removeAttribute('role');
				slide.removeAttribute('tabindex');
				slide.removeAttribute("aria-hidden")
				const interactiveElements = [...slide.querySelectorAll("a[href], button, input, select, textarea, [tabindex]")]
				if (interactiveElements.length !== 0) {
					interactiveElements.forEach(element => {
						element.setAttribute("tabindex", 0)
					})
				}
			});
			// Announce new slide to screen reader users -- multiple slider per view
			swiper.on('slideChange', () => {
				if (!slider.hasAttribute("data-isautoplay")) {
					const activeSlides = [...slider.querySelectorAll('.swiper-slide-visible')];
					const firstActiveSlide = activeSlides[0].getAttribute("aria-label");
					sliderAnnouncer.innerHTML = "";
					sliderAnnouncer.innerHTML = `Now displaying slides ${firstActiveSlide}`;
				}
				removeInert()
			});
			// removes aria-hidden = true and tabindex for slides that are visible (voiceover ada)
			function setupVisibileSlides() {
				sliderItems.forEach(sliderItem => {
					if (sliderItem.classList.contains("swiper-slide-visible")) {
						sliderItem.removeAttribute('aria-hidden');
						sliderItem.removeAttribute('tabindex');
						sliderItem.querySelectorAll('a').forEach(anchor => anchor.removeAttribute('tabindex'));
					}
					else {
						sliderItem.setAttribute('aria-hidden', "true");
						sliderItem.setAttribute('tabindex', "-1");
						sliderItem.querySelectorAll('a').forEach(anchor => anchor.setAttribute('tabindex', "-1"));
					}
				})
			}
			function toggleNavigationVisibility(swiperInstance) {
				const { slides, wrapperEl, navigation } = swiperInstance;
				const wrapperWidth = wrapperEl.scrollWidth;
				const containerWidth = swiperInstance.el.clientWidth;
				if (wrapperWidth <= containerWidth) {
					dataControlsContainer.classList.add("hide")
				} else {
					dataControlsContainer.classList.remove("hide")
				}
			}
			function setEqualSlideHeights() {
				let maxHeight = 0;
				sliderItems.forEach(sliderItem => sliderItem.height = '');
				sliderItems.forEach(sliderItem => {
					maxHeight = Math.max(maxHeight, sliderItem.offsetHeight);
				})
				sliderItems.forEach(sliderItem => {
					sliderItem.style.height = `${maxHeight}px`;
				});
			}
			// add inert attribute to inactive slides to avoid voiceover users from reaching offscreen slides
			function removeInert() {
				setTimeout(() => {
					const slides = [...slider.querySelectorAll("[data-swiper-slide]")];
					slides.forEach(slide => {
						if (slide.classList.contains("swiper-slide-visible")) {
							slide.removeAttribute("inert");
						}
						else {
							slide.setAttribute("inert", "");
						}
					})
				}, 0);
			}
			if (thumbButtons.length !== 0) {
				const sliderThumbType = slider.getAttribute("data-swiper-thumbs")
				const mainSlider = document.querySelector(`[data-type=${sliderThumbType}]`);
				const mainSliderSwiper = mainSlider.swiper

				thumbButtons.forEach(thumbButton => {
					thumbButton.addEventListener("keydown", e => {
						if (e.key === "Enter" || e.key === ' ') {
							e.preventDefault();
							const slideIndex = thumbButton.getAttribute("data-swiper-slide-index");
							mainSliderSwiper.slideTo(slideIndex)
						}
					})
				})
			}
		});
	}
});

window.addEventListener("DOMContentLoaded", e => {
	const reviewBox = document.getElementById("judgeme_product_reviews");
	const announcerElement = document.createElement("div")
	announcerElement.setAttribute("role", "status");
	announcerElement.classList.add("sr-only")
	announcerElement.innerHTML = "showing all reviews"
	if (reviewBox) {
		reviewBox.appendChild(announcerElement);
		const ratingButtons = [...reviewBox.querySelectorAll("[data-rating]")];
		const starLevel = reviewBox.querySelector(".jdgm-rev-widg__summary-stars")
		ratingButtons?.forEach(button => {
			button.addEventListener("click", e => {
				const ratingLevel = button.getAttribute("data-rating");
				announcerElement.innerHTML = "";
				announcerElement.innerHTML = `now showing ${ratingLevel} star reviews`
			})
		})
		setTimeout(() => {
			const startLevelAriaText = starLevel?.getAttribute("aria-label")
			starLevel?.setAttribute("aria-label", `${startLevelAriaText} out of 5`);
		}, 500);
		setTimeout(() => {
			const sortWrapper = reviewBox.querySelector(".jdgm-rev-widg__sort-wrapper")
			const sortSelect = reviewBox.querySelector(".jdgm-sort-dropdown")
			if (sortSelect) {
				sortSelect.removeAttribute("aria-label");
				sortSelect.setAttribute("id", "sort-pdp-reviews")
				const labelElement = document.createElement("label");
				labelElement.classList.add("jdgm-sort-dropdown-label")
				labelElement.setAttribute("for", "sort-pdp-reviews")
				labelElement.textContent = "Sort Reviews"
				sortWrapper.prepend(labelElement);
			}
		}, 500);
	}
}) 